import { default as __nuxt_component_0 } from "/opt/build/repo/components/App/Button.vue";
import { default as __nuxt_component_1 } from "/opt/build/repo/components/Partials/Common/Subaccount/Position/Mobile.vue";
import { default as __nuxt_component_2 } from "/opt/build/repo/components/Common/EmptyList.vue";
import { default as __nuxt_component_3 } from "/opt/build/repo/components/Common/Table/Body.vue";
import { default as __nuxt_component_4 } from "/opt/build/repo/components/Partials/Common/Subaccount/Position/Header.vue";
import { default as __nuxt_component_5 } from "/opt/build/repo/components/Partials/Common/Subaccount/Position/Row.vue";
import { default as __nuxt_component_6 } from "/opt/build/repo/components/Common/Table/Wrapper.vue";
import { default as __nuxt_component_7 } from "/opt/build/repo/components/App/HocLoading.vue";
"use strict";
import { defineComponent as _defineComponent } from "vue";
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "whitespace-nowrap" };
const _hoisted_2 = { class: "w-full h-full" };
const _hoisted_3 = {
  key: 0,
  class: "table"
};
import { GeneralException } from "@injectivelabs/exceptions";
import { Status, StatusType } from "@injectivelabs/utils";
export default /* @__PURE__ */ _defineComponent({
  __name: "Index",
  props: {
    denoms: {
      type: Array,
      default: () => []
    },
    side: {
      type: String,
      default: ""
    },
    status: {
      type: Object,
      default: () => new Status(StatusType.Loading)
    }
  },
  setup(__props) {
    const props = __props;
    const derivativeStore = useDerivativeStore();
    const positionStore = usePositionStore();
    const { $onError } = useNuxtApp();
    const { success } = useNotifications();
    const { t } = useLang();
    const tabCountElement = document.getElementById(
      "activity-position-tab-count-default"
    );
    const actionStatus = reactive(new Status(StatusType.Idle));
    const markets = computed(
      () => derivativeStore.markets.filter(
        (m) => props.denoms.some(
          (denom) => [m.baseToken.denom, m.quoteDenom].includes(denom)
        )
      ).map(({ marketId }) => marketId)
    );
    const filteredPositions = computed(
      () => positionStore.subaccountPositions.filter((position) => {
        const positionMatchesSide = !props.side || props.side === position.direction;
        const positionMatchesMarket = markets.value.length === 0 || markets.value.includes(position.marketId);
        return positionMatchesSide && positionMatchesMarket;
      })
    );
    onMounted(() => tabCountElement == null ? void 0 : tabCountElement.classList.add("hidden"));
    onUnmounted(() => tabCountElement == null ? void 0 : tabCountElement.classList.remove("hidden"));
    function closePosition(position) {
      const market = derivativeStore.markets.find(
        (m) => m.marketId === position.marketId
      );
      if (!market) {
        return Promise.reject(
          new GeneralException(
            Error(
              t("trade.position_market_not_found", {
                marketId: position.marketId
              })
            )
          )
        );
      }
      return positionStore.closePosition({ position, market });
    }
    function handleClosePositions() {
      actionStatus.setLoading();
      const action = filteredPositions.value.length === 1 ? closePosition(filteredPositions.value[0]) : positionStore.closeAllPosition(filteredPositions.value);
      action.then(() => {
        success({
          title: t("trade.positions_closed")
        });
      }).catch($onError).finally(() => {
        actionStatus.setIdle();
      });
    }
    return (_ctx, _cache) => {
      const _component_AppButton = __nuxt_component_0;
      const _component_PartialsCommonSubaccountPositionMobile = __nuxt_component_1;
      const _component_CommonEmptyList = __nuxt_component_2;
      const _component_CommonTableBody = __nuxt_component_3;
      const _component_PartialsCommonSubaccountPositionHeader = __nuxt_component_4;
      const _component_PartialsCommonSubaccountPositionRow = __nuxt_component_5;
      const _component_CommonTableWrapper = __nuxt_component_6;
      const _component_AppHocLoading = __nuxt_component_7;
      return _openBlock(), _createElementBlock("div", null, [
        (_openBlock(), _createBlock(_Teleport, { to: "#activity-position-tab-count" }, [
          _createElementVNode("span", null, "(" + _toDisplayString(_unref(filteredPositions).length) + ")", 1)
        ])),
        (_openBlock(), _createBlock(_Teleport, { to: "#activity-toolbar-action" }, [
          _unref(filteredPositions).length > 0 ? (_openBlock(), _createBlock(_component_AppButton, {
            key: 0,
            class: "text-red-500 bg-red-500 bg-opacity-10 font-semibold hover:text-white",
            status: _unref(actionStatus),
            "data-cy": "activity-cancel-all-button",
            onClick: handleClosePositions
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.$t("trade.closeAllPositions")), 1)
            ]),
            _: 1
          }, 8, ["status"])) : _createCommentVNode("", true)
        ])),
        _createVNode(_component_AppHocLoading, {
          class: "h-full",
          status: __props.status,
          "loader-class": __props.status.isLoading() ? "relative" : ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_CommonTableBody, {
                "show-empty": _unref(filteredPositions).length === 0,
                class: "sm:hidden mt-3 max-h-lg overflow-y-auto"
              }, {
                empty: _withCtx(() => [
                  _createVNode(_component_CommonEmptyList, {
                    message: _ctx.$t("trade.emptyPositions"),
                    class: "pb-4 grow bg-gray-900"
                  }, null, 8, ["message"])
                ]),
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredPositions), (position, index) => {
                    return _openBlock(), _createBlock(_component_PartialsCommonSubaccountPositionMobile, {
                      key: `mobile-positions-${index}-${position.marketId}`,
                      class: "col-span-1",
                      position
                    }, null, 8, ["position"]);
                  }), 128))
                ]),
                _: 1
              }, 8, ["show-empty"]),
              _createVNode(_component_CommonTableWrapper, {
                "break-md": "",
                class: "hidden sm:block"
              }, {
                default: _withCtx(() => [
                  _unref(filteredPositions).length > 0 ? (_openBlock(), _createElementBlock("table", _hoisted_3, [
                    _createVNode(_component_PartialsCommonSubaccountPositionHeader),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredPositions), (position, index) => {
                        return _openBlock(), _createBlock(_component_PartialsCommonSubaccountPositionRow, {
                          key: `positions-${index}-${position.marketId}`,
                          position
                        }, null, 8, ["position"]);
                      }), 128))
                    ])
                  ])) : (_openBlock(), _createBlock(_component_CommonEmptyList, {
                    key: 1,
                    "data-cy": "universal-table-nothing-found",
                    message: _ctx.$t("trade.emptyPositions"),
                    class: "pb-4 grow"
                  }, null, 8, ["message"]))
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["status", "loader-class"])
      ]);
    };
  }
});
